import { useState } from "react";
import {
  FaList,
  FaThLarge,
  FaPlus,
  FaArrowsAlt,
  FaCheck,
  FaTimes,
} from "react-icons/fa";
import "../../../styles/studio/folder/studioFolderControls.css";

const StudioFolderControls = ({
  viewMode,
  setViewMode,
  onAddItem,
  onReorderItems,
  onCancelReorder,
  globalLoading,
  setGlobalLoading, // ✅ NOW ACTUALLY USED
  isReordering = false,
  setIsReordering,
  setError,
  hasChanges = false,
}) => {
  const [savingOrder, setSavingOrder] = useState(false);

  /* -------- START REORDER MODE -------- */
  const handleStartReorder = () => {
    if (globalLoading) return;
    setIsReordering(true);
  };

  /* -------- SAVE ORDER -------- */
  const handleSaveOrder = async () => {
    if (!hasChanges) {
      setIsReordering(false);
      return;
    }

    setSavingOrder(true);
    setGlobalLoading(true); // 🔒 BLOCK ENTIRE UI

    try {
      await onReorderItems(); // API call
      setIsReordering(false);
    } catch (err) {
      setError(err.message);
    } finally {
      setSavingOrder(false);
      setGlobalLoading(false); // 🔓 UNLOCK UI
    }
  };

  /* -------- CANCEL REORDER -------- */
  const handleCancelReorder = () => {
    if (globalLoading) return;
    onCancelReorder?.();
    setIsReordering(false);
  };

  return (
    <div className="studio-folder-controls">
      {/* View Switcher */}
      <div className="studio-folder-view-switcher">
        <button
          className={`studio-folder-view-btn ${viewMode === "list" ? "active" : ""}`}
          onClick={() => setViewMode("list")}
          disabled={globalLoading || isReordering}
          title="List View"
        >
          <FaList />
        </button>

        <button
          className={`studio-folder-view-btn ${viewMode === "grid" ? "active" : ""}`}
          onClick={() => setViewMode("grid")}
          disabled={globalLoading || isReordering}
          title="Grid View"
        >
          <FaThLarge />
        </button>
      </div>

      {/* Actions */}
      <div className="studio-folder-actions">
        <button
          className="studio-folder-btn-add"
          onClick={onAddItem}
          disabled={globalLoading || isReordering}
        >
          <FaPlus /> Add Item
        </button>

        {!isReordering ? (
          <button
            className="studio-folder-btn-reorder"
            onClick={handleStartReorder}
            disabled={globalLoading}
            title="Reorder Items"
          >
            <FaArrowsAlt /> Reorder
          </button>
        ) : (
          <>
            <button
              className="studio-folder-btn-save-order"
              onClick={handleSaveOrder}
              disabled={globalLoading || savingOrder}
              title="Save Order"
            >
              <FaCheck /> Save
            </button>

            <button
              className="studio-folder-btn-cancel-order"
              onClick={handleCancelReorder}
              disabled={globalLoading || savingOrder}
              title="Cancel Reorder"
            >
              <FaTimes /> Cancel
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default StudioFolderControls;
